import { useId } from 'react';
import { T } from 'gt-react';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

/**
 * Worksheet picker for two-phase spreadsheet uploads. Callers render it only
 * when the workbook has more than one sheet; picking a sheet re-previews the
 * same uploaded document server-side (no re-upload) and the chosen name rides
 * along on ingest. Shared by the customer product mapping, Discounts v2 price
 * list, and exception price list uploads.
 */
export function WorkbookSheetPicker({
  sheetNames,
  value,
  onChange,
  disabled,
}: {
  sheetNames: string[];
  value: string;
  onChange: (sheetName: string) => void;
  disabled?: boolean;
}) {
  const labelId = useId();
  return (
    <div>
      <Label id={labelId} className="text-sm font-medium">
        <T context="spreadsheet upload worksheet picker label">Sheet</T>
      </Label>
      <Select value={value} onValueChange={onChange} disabled={disabled}>
        <SelectTrigger className="mt-1 w-full" aria-labelledby={labelId}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {sheetNames.map((sheetName) => (
            <SelectItem key={sheetName} value={sheetName}>
              {sheetName}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
